var _defs, _polygon, _line, _line2, _line3, _line4, _line5, _line6, _line7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeautyEarthandPlanetElements16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.14px;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.62 79.24 69.69 71.27 47.82 93.2 55.88 123.11 85.81 131.08 107.68 109.15 99.62 79.24"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.92,
    y1: 123.15,
    x2: 38.42,
    y2: 140.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.2,
    y1: 60.98,
    x2: 99.41,
    y2: 79.03
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.2,
    y1: 60.98,
    x2: 146.64,
    y2: 65.14
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 114.45,
    y1: 63.62,
    x2: 118.29,
    y2: 35.39
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 123.94,
    y1: 61.96,
    x2: 127.78,
    y2: 33.73
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.35,
    y1: 98.07,
    x2: 63.72,
    y2: 111.57
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.95,
    y1: 89.98,
    x2: 95.32,
    y2: 103.47
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeautyEarthandPlanetElements16);
export default __webpack_public_path__ + "static/media/Beauty, Earth and Planet Elements-16.9e3c7ced94289f39d6dd0296e7c218ca.svg";
export { ForwardRef as ReactComponent };